import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import Lenis from "lenis";
import HomePage from "@/pages/HomePage";
import PolicyPage from "@/pages/PolicyPage";
import GuidePage from "@/pages/GuidePage";
import FaqPage from "@/pages/FaqPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import ConditionsPage from "@/pages/ConditionsPage";
import { GUIDES } from "@/data/guides";

const useLenis = () => {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);
};

const ScrollManager = () => {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash) {
            const t = setTimeout(() => {
                const el = document.getElementById(hash.slice(1));
                if (!el) return;
                if (window.__lenis) window.__lenis.scrollTo(el, { offset: -96 });
                else el.scrollIntoView({ behavior: "smooth" });
            }, 120);
            return () => clearTimeout(t);
        }
        if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
        else window.scrollTo(0, 0);
    }, [pathname, hash]);
    return null;
};

function App() {
    useLenis();
    return (
        <div className="App">
            <div className="grain-overlay" aria-hidden="true" />
            <BrowserRouter>
                <ScrollManager />
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    {GUIDES.map((g) => (
                        <Route key={g.slug} path={`/${g.slug}`} element={<GuidePage slug={g.slug} />} />
                    ))}
                    <Route path="/about" element={<AboutPage />} />
                    <Route path="/faq" element={<FaqPage />} />
                    <Route path="/contact" element={<ContactPage />} />
                    <Route path="/conditions-and-concerns" element={<ConditionsPage />} />
                    <Route path="/privacy-policy" element={<PolicyPage slug="privacy-policy" />} />
                    <Route path="/terms-and-conditions" element={<PolicyPage slug="terms-and-conditions" />} />
                    <Route path="/medical-disclaimer" element={<PolicyPage slug="medical-disclaimer" />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
